class Ciel {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // スライダー

    var swiper = new Swiper(".cielSwiper", {
      autoplay: {
        delay: 2000,
      },
      speed: 1500,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',  //ページネーションの要素のセレクタ
        type: 'bullets',  //ページネーションのタイプ
      },
      breakpoints: {
        960: {
          slidesPerView: 2.4,
          spaceBetween: 30,
        }
      }
    });

    var swiper = new Swiper(".ciel-blog-Swiper", {
      autoplay: {
        delay: 2000,
      },
      speed: 1500,
      slidesPerView: 1.4,
      spaceBetween: 0,
      centeredSlides: true,
      // loop: true,
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',  //ページネーションの要素のセレクタ
        type: 'bullets',  //ページネーションのタイプ
      },
      breakpoints: {
        960: {
          centeredSlides: false,
          slidesPerView: 4,
          spaceBetween: 30,
        }
      }
    });


    // ページ内遷移

    $(function(){
      $("a[href^='#']").click(function(){
        var target = $(this.hash);
        var adjust = 70;
        var position = $(target).offset().top  - adjust;
        $('html,body').animate({scrollTop: position}, 400);
        return false;
      });
    });



    // メニューチェックイベント

    function menuSelect(){
      const menu = document.querySelectorAll(".menu-content__genre");
      const menuList = document.querySelectorAll(".menu-content__price");
      const firstMenu = document.querySelector(".menu-active");
      let menuVal;



      menu.forEach(el => {
        el.addEventListener("click", () => {


          menu.forEach(allCheck => {
            if(allCheck.classList.contains("is-active")){
              allCheck.classList.remove("is-active")
            }
          })
          el.classList.add("is-active")

          menuVal = el.getAttribute("value");


          menuList.forEach(el => {
            if(el.classList.contains("menu-active")){
              el.classList.remove("menu-active")
            }
            el.style.display = "none";
            if(menuVal === el.getAttribute("data-menu")){
              el.style.display = "flex";
              el.style.opacity = 1;
            }
          })

          scrollTo(0, $('.menu-content__inner').offset().top);

        })
      })

    }

    menuSelect();


    //メニュー

    function humMenu(){
      const hum = document.querySelector(".nav-hum");
      const menuOpen = document.querySelector(".ciel-hum-menu");
      const menuList = document.querySelectorAll(".hum-list")
      // console.log(menuList);
      // console.log(menuOpen);

      hum.addEventListener("click", () => {
        hum.classList.toggle("is-active")
        menuOpen.classList.toggle("is-active")
      })

      menuList.forEach(el => {
        el.addEventListener("click" , () => {
          hum.classList.remove("is-active")
          menuOpen.classList.remove("is-active")

        })
      })
    }

    humMenu();




  }
}
